import { Component } from "@angular/core";
import { InputManager } from "../game-engine/input-manager";
var SkillBar = (function () {
    function SkillBar(input_manager_) {
        this.input_manager_ = input_manager_;
    }
    ;
    SkillBar.decorators = [
        { type: Component, args: [{
                    selector: "skill-bar",
                    template: "\n    <div #skillbar id=\"skill-bar\" [style.height.px]=\"0.2 * skillbar.clientWidth\">\n        <skill-button [keybind]=\"1\"></skill-button>\n        <skill-button [keybind]=\"2\"></skill-button>\n        <skill-button [keybind]=\"3\"></skill-button>\n        <skill-button [keybind]=\"4\"></skill-button>\n        <skill-button [keybind]=\"5\"></skill-button>\n    </div>\n    \n    ",
                    styles: ["\n    #skill-bar {\n        background-color: light-grey;\n        width: 52%;\n        position: absolute;\n        border: 0.25em solid white;\n        bottom: 4%;\n        left: 24%;\n        margin: 0;     \n        z-index: 10;\n    }\n    "]
                },] },
    ];
    SkillBar.ctorParameters = function () { return [
        { type: InputManager, },
    ]; };
    return SkillBar;
}());
export { SkillBar };
;
//# sourceMappingURL=skill-bar.component.js.map